export class BookingPaymentOverride {
    DaysFromCheckIn: number
    DepositMultiplier: number;
    WaiverMultiplier: number;
}